import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_CUSTOMER_ONBOARDING_EMAIL } from './schema';

const MUTATION = gql`
  mutation SaveCustomerOnboardingEmail(
    $customerId: ID!
    $emailContent: String!
    $subject: String!
    $enabled: Boolean
  ) {
    saveCustomerOnboardingEmail(
      customerId: $customerId
      emailContent: $emailContent
      subject: $subject
      enabled: $enabled
    ) {
      ...CustomerOnboardingEmail
    }
  }
  ${FRAGMENT_CUSTOMER_ONBOARDING_EMAIL}
`;

export const saveCustomerOnboardingEmail = ({ customerId, emailContent, subject, enabled }) =>
  executeGqlMutation({
    mutation: MUTATION,
    variables: { customerId, emailContent, subject, enabled },
  }).then(({ data }) => getSingleProp(data));
